<!doctype html>
<html lang="en">
  <head>
    <title>Print BIP</title>
  </head>
  <body id="pdf-report-data" #pdfContent>
    <div class="pdf-content" *ngIf="printData?.caseData as report">
      <div style="text-align: center; font-size: 16px">
        <div>
          <b
            >{{
              printData?.bipTemplate?.templateName ||
                'Behavior Intervention Plan'
            }}
            for
            {{ report.student.firstName }}
            {{ report.student.lastName }}</b
          >
        </div>
      </div>
      <br />

      <!-- Plan Information -->
      <ng-container
        [ngTemplateOutlet]="sectionHeaderTpl"
        [ngTemplateOutletContext]="{
          title: 'Plan Information',
          color: '#1D2939',
        }">
      </ng-container>
      <div
        *ngFor="let row of getPlanInformationFields() | chunk: 2"
        data-pdfmake-type="columns">
        <ng-container *ngFor="let field of row">
          <div data-pdfmake='{"width":"*"}'>
            <div class="datalabel">{{ field.label }}</div>
            <div class="dataValue">
              <b>{{ field.value }}</b>
            </div>
            <br />
          </div>
        </ng-container>
        <ng-container *ngIf="row.length === 1">
          <div data-pdfmake='{"width":"*"}'></div>
        </ng-container>
      </div>
      <br />

      <!-- Per-behavior report -->
      <div
        *ngFor="let behavior of report.caseBehaviors; let i = index"
        [attr.data-pdfmake]="i > 0 ? pageBreakBefore : null">
        <table
          data-pdfmake='{"widths": ["*"], "heights": 20, "dontBreakRows": true, "layout": {  "hLineColor": "#eaecf0",  "vLineColor": "#eaecf0"}}'>
          <tr>
            <th
              style="font-size: 18px"
              [attr.data-pdfmake]="getSectionHeaderAttr(behaviorHeaderColor)">
              <b
                >{{ i + 1 }}. Challenging Behavior:
                {{ behavior?.behaviorCategoryName }}</b
              >
            </th>
          </tr>
        </table>
        <br />

        <div *ngFor="let meta of getVisibleSections(behavior); let k = index">
          <ng-container
            [ngTemplateOutlet]="sectionHeaderTpl"
            [ngTemplateOutletContext]="{
              number: i + 1 + '.' + (k + 1),
              title: getSectionDisplayName(meta.section.sectionName),
              color: meta.color,
            }">
          </ng-container>

          <ng-container [ngSwitch]="meta.kind">
            <ng-container
              *ngSwitchCase="'behavior-definition'"
              [ngTemplateOutlet]="behaviorDefinitionTpl"
              [ngTemplateOutletContext]="{ behavior: behavior }">
            </ng-container>
            <ng-container
              *ngSwitchCase="'strategies'"
              [ngTemplateOutlet]="strategiesTpl"
              [ngTemplateOutletContext]="{
                strategies: behavior.caseBehaviorStrategies,
              }">
            </ng-container>
            <ng-container
              *ngSwitchCase="'strategy-details'"
              [ngTemplateOutlet]="strategyDetailsTpl"
              [ngTemplateOutletContext]="{
                strategies: behavior.caseBehaviorStrategies,
              }">
            </ng-container>
            <ng-container
              *ngSwitchCase="'safety-plan'"
              [ngTemplateOutlet]="safetyPlanTpl">
            </ng-container>
            <ng-container
              *ngSwitchCase="'behavior-screener'"
              [ngTemplateOutlet]="behaviorScreenerTpl"
              [ngTemplateOutletContext]="{ behavior: behavior }">
            </ng-container>
            <ng-container
              *ngSwitchCase="'reports'"
              [ngTemplateOutlet]="reportsTpl"
              [ngTemplateOutletContext]="{ behavior: behavior }">
            </ng-container>
            <ng-container
              *ngSwitchCase="'custom-questions-bucket'"
              [ngTemplateOutlet]="customQuestionsBucketTpl"
              [ngTemplateOutletContext]="{
                customQuestions: getCustomQuestionsBucket(behavior),
              }">
            </ng-container>
            <ng-container
              *ngSwitchCase="'custom-question'"
              [ngTemplateOutlet]="customQuestionTpl"
              [ngTemplateOutletContext]="{
                section: meta.section,
                behavior: behavior,
              }">
            </ng-container>
          </ng-container>
        </div>
      </div>

      <!-- Approvals: always printed once at the very end of the report -->
      <div [attr.data-pdfmake]="pageBreakBefore">
        <ng-container
          [ngTemplateOutlet]="sectionHeaderTpl"
          [ngTemplateOutletContext]="{
            number: getApprovalsSectionNumber(),
            title: 'Approvals',
            color: '#1D2939',
          }">
        </ng-container>
        <ng-container [ngTemplateOutlet]="approvalsTpl"></ng-container>
      </div>

      <!-- Questionnaires: lists the plans/attachments merged right after this page -->
      <ng-container *ngIf="getAttachmentPlanGroups().length > 0">
        <div [attr.data-pdfmake]="pageBreakBefore">
          <ng-container
            [ngTemplateOutlet]="sectionHeaderTpl"
            [ngTemplateOutletContext]="{
              number: getQuestionnairesSectionNumber(),
              title: 'Questionnaires',
              color: '#1D2939',
            }">
          </ng-container>
          <div *ngFor="let planGroup of getAttachmentPlanGroups()">
            <table
              data-pdfmake='{"widths": ["*"], "dontBreakRows": true, "layout": {"hLineColor": "#eaecf0", "vLineColor": "#eaecf0"}}'>
              <tr>
                <th
                  style="font-size: 18px"
                  [attr.data-pdfmake]="getPlanTitleAttr()">
                  {{ planGroup.planTypeName || 'Plan' }}
                </th>
              </tr>
              <tr>
                <td data-pdfmake='{"margin": [8,8,8,8]}'>
                  <div
                    *ngFor="let attachment of planGroup.attachments"
                    data-pdfmake='{"margin": [0,0,0,4]}'
                    data-pdfmake-type="columns">
                    <div data-pdfmake='{"width":14}' class="dataValue">•</div>
                    <div data-pdfmake='{"width":"*"}' class="dataValue">
                      <b>{{ attachment.name || 'Attachment' }}</b>
                    </div>
                  </div>
                </td>
              </tr>
            </table>
            <br />
          </div>
        </div>
      </ng-container>
    </div>

    <!-- ===== Section templates ===== -->

    <ng-template
      #sectionHeaderTpl
      let-number="number"
      let-title="title"
      let-color="color">
      <table
        data-pdfmake='{"widths": ["*"], "heights": 20, "dontBreakRows": true, "layout": {"hLineColor": "#eaecf0", "vLineColor": "#eaecf0"}}'>
        <tr>
          <th
            style="font-size: 16px"
            [attr.data-pdfmake]="getSectionHeaderAttr(color)">
            <b>{{ number ? number + '. ' : '' }}{{ title }}</b>
          </th>
        </tr>
      </table>
      <br />
    </ng-template>

    <ng-template #behaviorDefinitionTpl let-behavior="behavior">
      <ng-container *ngFor="let item of getOrderedBehaviorQuestionnaires()">
        <div
          data-pdfmake='{"margin": [0,0,0,7]}'
          data-pdfmake-type="columns"
          *ngIf="
            item.applicationObjectId === lookUp_Ids.CaseBehaviorTypes &&
            !item.questionId
          ">
          <div data-pdfmake='{"width":175}' class="datalabel">
            Behavior Types:
          </div>
          <div data-pdfmake='{"width":"*"}' class="datalabel">
            <b>{{
              behavior?.caseBehaviorTypeIds?.length > 0
                ? behavior?.caseBehaviorTypeIds.join(', ')
                : 'None Selected'
            }}</b>
            <b>{{
              behavior?.caseBehaviorTypeDescriptionIds?.length > 0
                ? ', Other- ' +
                  behavior?.caseBehaviorTypeDescriptionIds.join(', ')
                : ''
            }}</b>
          </div>
        </div>
        <div
          data-pdfmake='{"margin": [0,0,0,7]}'
          data-pdfmake-type="columns"
          *ngIf="
            item.applicationObjectId === lookUp_Ids.OperationalDefinition &&
            !item.questionId
          ">
          <div data-pdfmake='{"width":175}' class="datalabel">
            Operational Definition:
          </div>
          <div data-pdfmake='{"width":"*"}' class="datalabel">
            <b
              >{{
                wrapLongText(behavior?.operationalDefinition) ||
                  'Nothing Entered'
              }}
            </b>
          </div>
        </div>
        <div
          data-pdfmake='{"margin": [0,0,0,7]}'
          data-pdfmake-type="columns"
          *ngIf="
            item.applicationObjectId === lookUp_Ids.Frequency &&
            !item.questionId
          ">
          <div data-pdfmake='{"width":175}' class="datalabel">Frequency:</div>
          <div data-pdfmake='{"width":"*"}' class="datalabel">
            <b>{{
              !!behavior?.behaviourFrequencyId
                ? getFrequencyAnswer(behavior)
                : 'None Selected'
            }}</b>
          </div>
        </div>
        <div
          data-pdfmake='{"margin": [0,0,0,7]}'
          data-pdfmake-type="columns"
          *ngIf="
            item.applicationObjectId === lookUp_Ids.Intensity &&
            !item.questionId
          ">
          <div data-pdfmake='{"width":175}' class="datalabel">Intensity:</div>
          <div data-pdfmake='{"width":"*"}' class="dataValue">
            <b>{{
              !!behavior?.behaviourIntensityId
                ? behavior?.behaviourIntensityName
                : 'None Selected'
            }}</b>
          </div>
        </div>
        <div
          data-pdfmake='{"margin": [0,0,0,7]}'
          data-pdfmake-type="columns"
          *ngIf="
            item.applicationObjectId === lookUp_Ids.Environmnets &&
            !item.questionId
          ">
          <div data-pdfmake='{"width":175}' class="datalabel">
            Environments:
          </div>
          <div data-pdfmake='{"width":"*"}' class="dataValue">
            <b>{{
              behavior?.caseBehaviorEnvironmentIds?.length > 0
                ? behavior?.caseBehaviorEnvironmentIds.join(', ')
                : 'None Selected'
            }}</b>
          </div>
        </div>
        <div
          data-pdfmake='{"margin": [0,0,0,7]}'
          data-pdfmake-type="columns"
          *ngIf="
            item.applicationObjectId === lookUp_Ids.SettingEvents &&
            !item.questionId
          ">
          <div data-pdfmake='{"width":175}' class="datalabel">
            Setting Events:
          </div>
          <div data-pdfmake='{"width":"*"}' class="dataValue">
            <b>{{
              behavior?.caseBehaviorSettingEventIds?.length > 0
                ? behavior?.caseBehaviorSettingEventIds.join(', ')
                : 'None Selected'
            }}</b>
          </div>
        </div>
        <div
          data-pdfmake='{"margin": [0,0,0,7]}'
          data-pdfmake-type="columns"
          *ngIf="
            item.applicationObjectId === lookUp_Ids.Antecedents &&
            !item.questionId
          ">
          <div data-pdfmake='{"width":175}' class="datalabel">Antecedents:</div>
          <div data-pdfmake='{"width":"*"}' class="dataValue">
            <b>{{
              behavior?.caseBehaviorAntecedentIds?.length > 0
                ? behavior?.caseBehaviorAntecedentIds.join(', ')
                : 'None Selected'
            }}</b>
          </div>
        </div>
        <div
          data-pdfmake='{"margin": [0,0,0,7]}'
          data-pdfmake-type="columns"
          *ngIf="
            item.applicationObjectId === lookUp_Ids.Consequences &&
            !item.questionId
          ">
          <div data-pdfmake='{"width":175}' class="datalabel">
            Consequences:
          </div>
          <div data-pdfmake='{"width":"*"}' class="dataValue">
            <b>{{
              behavior?.caseBehaviorConsequenceIds?.length > 0
                ? behavior?.caseBehaviorConsequenceIds.join(', ')
                : 'None Selected'
            }}</b>
            <b>{{
              behavior?.caseBehaviorConsequenceDescriptionIds?.length > 0
                ? ', Other- ' +
                  behavior?.caseBehaviorConsequenceDescriptionIds.join(', ')
                : ''
            }}</b>
          </div>
        </div>
        <div
          data-pdfmake='{"margin": [0,0,0,7]}'
          data-pdfmake-type="columns"
          *ngIf="
            item.applicationObjectId === lookUp_Ids.Goals && !item.questionId
          ">
          <div data-pdfmake='{"width":175}' class="datalabel">Goals:</div>
          <div data-pdfmake='{"width":"*"}' class="dataValue">
            <b>{{ wrapLongText(behavior?.goals) || 'Nothing Entered' }}</b>
          </div>
        </div>

        <ng-container
          *ngIf="
            !!item.questionId &&
            getQuestionAnswer(behavior, item.questionId) as qa
          ">
          <div data-pdfmake='{"margin": [0,0,0,7]}' data-pdfmake-type="columns">
            <div data-pdfmake='{"width":175}' class="datalabel">
              {{ qa.customQuestion }}:
            </div>
            <div data-pdfmake='{"width":"*"}' class="dataValue">
              <b>{{ wrapLongText(qa?.answer) || 'Nothing Entered' }}</b>
            </div>
          </div>
        </ng-container>
      </ng-container>
      <br />
    </ng-template>

    <ng-template #strategiesTpl let-strategies="strategies">
      <div *ngFor="let strategy of strategies">
        <table
          data-pdfmake='{"widths": ["*"], "dontBreakRows": true, "layout": {"hLineColor": "#eaecf0", "vLineColor": "#eaecf0"}}'>
          <tr>
            <th
              style="font-size: 18px"
              [attr.data-pdfmake]="getStrategyTitleAttr()">
              {{ strategy?.title }}
            </th>
          </tr>
          <tr>
            <td data-pdfmake='{"margin": [8,8,8,8]}'>
              <div
                style="font-size: 13px"
                data-pdfmake='{"color": "#027A48", "margin": [0,0,0,8]}'>
                <b>Details</b>
              </div>
              <div class="dataValue">
                <b>{{
                  wrapLongText(strategy?.description) || 'No details available.'
                }}</b>
              </div>
            </td>
          </tr>
          <tr>
            <td data-pdfmake='{"margin": [8,8,8,8]}'>
              <div
                style="font-size: 13px"
                data-pdfmake='{"color": "#027A48", "margin": [0,0,0,8]}'>
                <b>Note</b>
              </div>
              <div class="dataValue">
                <b>{{
                  wrapLongText(strategy?.notes) || 'No notes available.'
                }}</b>
              </div>
            </td>
          </tr>
          <ng-container
            [ngTemplateOutlet]="strategyGuidelinesRowsTpl"
            [ngTemplateOutletContext]="{ strategy: strategy }">
          </ng-container>
        </table>
        <br />
      </div>
    </ng-template>

    <ng-template #strategyDetailsTpl let-strategies="strategies">
      <div *ngFor="let strategy of strategies">
        <table
          data-pdfmake='{"widths": ["*"], "dontBreakRows": true, "layout": {"hLineColor": "#eaecf0", "vLineColor": "#eaecf0"}}'>
          <tr>
            <th
              style="font-size: 18px"
              [attr.data-pdfmake]="getStrategyTitleAttr()">
              {{ strategy?.title }}
            </th>
          </tr>
          <tr>
            <td data-pdfmake='{"margin": [8,8,8,8]}'>
              <div
                style="font-size: 13px"
                data-pdfmake='{"color": "#027A48", "margin": [0,0,0,8]}'>
                <b>Details</b>
              </div>
              <ng-container
                *ngIf="
                  getStrategyDetailPromptColumns([strategy]).length > 0;
                  else plainStrategyDetailTpl
                ">
                <div
                  *ngFor="
                    let column of getStrategyDetailPromptColumns([strategy])
                  "
                  data-pdfmake='{"margin": [0,4,0,0]}'>
                  <div class="datalabel">{{ column }}:</div>
                  <div class="dataValue">
                    <b>{{
                      wrapLongText(
                        getStrategyDetailAnswerForColumn(strategy, column)
                      )
                    }}</b>
                  </div>
                </div>
              </ng-container>
              <ng-template #plainStrategyDetailTpl>
                <div data-pdfmake='{"margin": [0,4,0,0]}' class="dataValue">
                  <b>{{
                    wrapLongText(strategy?.details) || 'No details available.'
                  }}</b>
                </div>
              </ng-template>
            </td>
          </tr>
          <tr>
            <td data-pdfmake='{"margin": [8,8,8,8]}'>
              <div
                style="font-size: 13px"
                data-pdfmake='{"color": "#027A48", "margin": [0,0,0,8]}'>
                <b>Note</b>
              </div>
              <div class="dataValue">
                <b>{{
                  wrapLongText(strategy?.notes) || 'No notes available.'
                }}</b>
              </div>
            </td>
          </tr>
          <ng-container
            [ngTemplateOutlet]="strategyGuidelinesRowsTpl"
            [ngTemplateOutletContext]="{ strategy: strategy }">
          </ng-container>
        </table>
        <br />
      </div>
    </ng-template>

    <ng-template #strategyGuidelinesRowsTpl let-strategy="strategy">
      <ng-container
        *ngIf="
          printData?.PrintOptions?.isIncludeStrategyGuidelines ||
          printData?.bipTemplate?.isIncludeStrategyGuidelines
        ">
        <tr>
          <td data-pdfmake='{"fillColor": "#F6FEF9", "margin": [8,8,8,8]}'>
            <div
              style="font-size: 13px"
              data-pdfmake='{"color": "#027A48", "margin": [0,0,0,8]}'>
              <b>Guidelines</b>
            </div>
            <ng-container
              *ngIf="strategy?.guidelines?.length > 0; else noGuidelinesTpl">
              <div
                *ngFor="let item of strategy?.guidelines"
                data-pdfmake='{"margin": [0,0,0,6]}'
                data-pdfmake-type="columns">
                <div data-pdfmake='{"width":16, "color": "#12B76A"}'>
                  <b>•</b>
                </div>
                <div data-pdfmake='{"width":"*"}' class="dataValue">
                  {{ wrapLongText(item?.guideline) }}
                </div>
              </div>
            </ng-container>
            <ng-template #noGuidelinesTpl>
              <div class="dataValue">No guidelines available.</div>
            </ng-template>
          </td>
        </tr>
      </ng-container>
    </ng-template>

    <ng-template #safetyPlanTpl>
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":175}' class="datalabel">Safety Plan:</div>
        <div data-pdfmake='{"width":"*"}' class="dataValue">
          <b>{{ printData?.caseData?.isEnabledSafetyPlan ? 'Yes' : 'No' }}</b>
        </div>
      </div>
      <br />
    </ng-template>

    <ng-template #behaviorScreenerTpl let-behavior="behavior">
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":175}' class="datalabel">
          Behavior Functions:
        </div>
        <div data-pdfmake='{"width":"*"}' class="dataValue">
          <b>{{
            getBehaviorFunctionNames(behavior).length > 0
              ? getBehaviorFunctionNames(behavior).join(', ')
              : 'None Selected'
          }}</b>
        </div>
      </div>
      <br />
      <ng-container *ngIf="behavior.behaviorFunctionGraphImage">
        <img
          data-pdfmake='{"width":350, "alignment":"center"}'
          [src]="behavior.behaviorFunctionGraphImage"
          alt="Behavior Function Graph"
          class="chartImage" />
        <br />
      </ng-container>
    </ng-template>

    <ng-template #reportsTpl let-behavior="behavior">
      <ng-container *ngFor="let data of behavior.groupedGraphsAndComments">
        <div *ngFor="let graphData of data.graphs; let i = index">
          <img
            data-pdfmake='{"width":552}'
            [src]="graphData.graph"
            [alt]="'Chart_' + i"
            class="chartImage" />
          <br />
        </div>
        <div *ngIf="data.commentsData?.length > 0">
          <div class="extraLineHeight">
            <b>Note:</b>
            <hr
              data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />
            <br />
          </div>
          <ng-container *ngFor="let commentData of data.commentsData">
            <div
              class="extraLineHeight"
              style="font-size: 16px"
              data-pdfmake='{"color": "#128E55"}'>
              <b>Data Date: {{ commentData.dataDate | date: 'MM/dd/yyyy' }}</b>
              <br />
            </div>
            <div *ngFor="let comment of commentData.comments">
              <table
                data-pdfmake='{"widths": ["*"], "heights": 10,"dontBreakRows": true, "layout": { "hLineColor": "#eaecf0",  "vLineColor": "#eaecf0"}}'>
                <thead>
                  <tr>
                    <th style="display: none">Note Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td
                      class="font10"
                      data-pdfmake='{"fillColor": "#F9FAFB","padding": [0,3,0,3]}'>
                      <span class="commentLabel">
                        <b>Note Date: </b>
                        {{ comment.createdOn | userDate: 'MM/dd/yyyy hh:mm a' }}
                        &nbsp;-&nbsp; {{ comment.createdByName }}
                      </span>
                      <br />
                      <span style="color: #101828">{{
                        wrapLongText(comment?.comment)
                      }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <br />
          </ng-container>
        </div>
      </ng-container>
    </ng-template>

    <ng-template #approvalsTpl>
      <table
        data-pdfmake='{"widths": ["25%", "25%", "25%", "25%"], "heights": 30, "layout": { "hLineColor": "#eaecf0", "vLineColor": "#eaecf0"}}'>
        <tr>
          <th data-pdfmake='{"fillColor": "#eaecf0", "margin": [0,7,0,7]}'>
            Name
          </th>
          <th data-pdfmake='{"fillColor": "#eaecf0", "margin": [0,7,0,7]}'>
            Role
          </th>
          <th data-pdfmake='{"fillColor": "#eaecf0", "margin": [0,7,0,7]}'>
            Signature
          </th>
          <th data-pdfmake='{"fillColor": "#eaecf0", "margin": [0,7,0,7]}'>
            Date
          </th>
        </tr>
        <tr *ngFor="let item of signatures">
          <td>{{ '' }}</td>
          <td>{{ '' }}</td>
          <td>{{ '' }}</td>
          <td>{{ '' }}</td>
        </tr>
      </table>
    </ng-template>

    <ng-template
      #customQuestionsBucketTpl
      let-customQuestions="customQuestions">
      <div *ngFor="let question of customQuestions">
        <div class="datalabel">{{ question?.customQuestion }}</div>
        <div class="dataValue">
          <b>{{ wrapLongText(question?.answer) || 'Nothing Entered' }}</b>
        </div>
        <br />
      </div>
    </ng-template>

    <ng-template
      #customQuestionTpl
      let-section="section"
      let-behavior="behavior">
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":"*"}' class="dataValue">
          <b>{{
            wrapLongText(getCustomQuestionAnswer(section, behavior)?.answer) ||
              'Nothing Entered'
          }}</b>
        </div>
      </div>
      <br />
    </ng-template>
  </body>
</html>
